import { Component, computed, effect, inject } from '@angular/core';
import { toSignal } from "@angular/core/rxjs-interop";
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ApplicationGroupsService, AuthService } from "@bayclubs/horizon";
import { filter, map } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
	private readonly msalAuth = inject(AuthService);

	// Authorization is simply "signed in with Azure AD".
	private readonly isAuthorized = computed(() => this.msalAuth.isAuthenticated());

	// routes marked with data.chromeless render without the menu and footer (e.g. the tv wallboard)
	readonly chromeless = toSignal(
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map(() => {
				let route = this.router.routerState.snapshot.root;
				while (route.firstChild) {
					route = route.firstChild;
				}
				return route.data['chromeless'] === true;
			})
		),
		{ initialValue: false }
	);

	readonly showMenubar = computed(() => this.isAuthorized() && !this.chromeless());

	constructor(private router: Router, private applicationGroupsService: ApplicationGroupsService) {
        this.redirectHashLocationLinksToPathLocation();
		this.initHorizonProviders();
    }

    private redirectHashLocationLinksToPathLocation() {
        this.router.events
            .pipe(filter(event => event instanceof NavigationStart && /^\/#/.test(event.url)))
            .subscribe(event => {
                if (event instanceof NavigationStart) {
                    console.debug('Found path created with HashLocationStrategy. Redirecting to PathLocationStrategy');
                    this.router.navigateByUrl(event.url.replace('/#', ''));
                }
            });
    }

	private initHorizonProviders(): void {
		effect(() => {
			if (this.msalAuth.isAuthenticated()) {
				this.applicationGroupsService.init();
			}
		});
	}
}
